import { render, staticRenderFns } from "./Stats.vue?vue&type=template&id=7ac825eb"
import script from "./Stats.js?vue&type=script&lang=js&external"
export * from "./Stats.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports